import type { UtilityContext } from '@change-corgi/core-react/utilityContext';

import type { DeleteCommentMutation, DeleteCommentMutationVariables } from './deleteComment.graphql';
import { DeleteComment } from './deleteComment.graphql';

export type DeleteCommentInput = DeleteCommentMutationVariables['input'];

export async function deleteComment({ gql: { fetch } }: UtilityContext, commentId: string): Promise<void> {
	const { data } = await fetch<DeleteCommentMutation, DeleteCommentMutationVariables>({
		query: DeleteComment,
		variables: {
			input: {
				commentId,
			},
		},
		rejectOnError: true,
	});

	if (!data.deleteComment?.success)
		throw new Error(`Unable to delete comment (${data.deleteComment?.reason || 'unknown'})`);
}
